import {SurveyAggregationService} from "crqlar-react-common/dist/services/aggregation/surveyAggregation.service";
import {enqueueSnackbar} from "notistack";
import {useTranslation} from "react-i18next";
import {useQuery} from "react-query";
import {SURVEY_EVALUATION_QUERY_KEY} from "../shared/surveyQueryRefresh";
import {SurveyListSubmissionDialog} from "../submissions/SurveyListSubmissionDialog";

interface Props {
    submissionId: string
    questionId: string
    onClose: () => void
}

/** Opens the source response from either an evaluation bucket or a written answer. */
export default function SurveyEvaluationSubmissionDialog({submissionId, questionId, onClose}: Props) {
    const {t} = useTranslation();
    const submissionQuery = useQuery(
        [SURVEY_EVALUATION_QUERY_KEY, 'answers', 'submission', submissionId],
        () => SurveyAggregationService.listSubmissions({id: [submissionId], limit: {offset: 0, limit: 1}}),
        {
            enabled: !!submissionId,
            refetchOnWindowFocus: false,
            onSuccess: page => {
                if (page.content?.length) return;
                onClose();
                enqueueSnackbar(t('The submission could not be loaded.'), {variant: 'error'});
            },
            onError: error => {
                console.error('Could not open submission', error);
                onClose();
                enqueueSnackbar(t('The submission could not be loaded.'), {variant: 'error'});
            },
        }
    );
    const submission = submissionQuery.data?.content?.[0];

    return submission ? (
        <SurveyListSubmissionDialog
            submission={submission}
            initialQuestionId={questionId}
            onClose={onClose}
        />
    ) : null;
}
